<div class="imageAttachContainer">

  <div class="send-file">
    <div class="" [uploadInputFor]="This">
      <div class="">
        <button [matBadgeHidden]="countUploadedImages <= 0" matBadge="{{ countUploadedImages }}" matBadgeColor="accent" matBadgeSize="small" mat-icon-button class="btn border-0" (click)="fileInput.click()">
          <mat-icon aria-hidden="false" aria-label="add photo button" *ngIf="!this.services.progress">add_a_photo</mat-icon>
          <mat-spinner class="textInputBar__loader" diameter="20" *ngIf="this.services.progress"></mat-spinner>
        </button>
          <input hidden multiple (change)="onFileSelected()" #fileInput type="file" id="file">
      </div>
    </div>
  </div>

  <div>
    <div class="" *ngIf="images.length > 0" [uploadInputFor]="This">
      <button class="del-img-icon" mat-icon-button (click)="deleteImages()" >
        <mat-icon>delete_outline</mat-icon>
      </button>
  </div>
  </div>
</div>
